const CARD_NOTE_STATE_BASE = Object.freeze({
    blank: false,
    to: '',
    from: '',
    message: ''
});

window.bundleApp = {
    state: {
        firstRun: true,
        appRoot: null,
        boxIdToAdd: undefined,
        activeProductModal: undefined,
        cardModalOpen: false,
        sortBy: 'Default',
        tagFilters: [],
        priceFilter: [],
        cardNotes: JSON.parse(JSON.stringify(CARD_NOTE_STATE_BASE)),
        cardModalSaved: false,
        scrollPosition: 0
    },

    run: function(newProps) {
        if (this.state.firstRun) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const paramFilters = []
            urlParams.forEach(param => {
                if (param.includes('::')) {
                    paramFilters.push(param);
                }
            });

            this.setState({
                firstRun: false,
                appRoot: document.getElementById('bundle-builder-app--bundle--root'),
                boxIdToAdd: document.querySelector('.bundle-builder--add-to-bundle-form .add-box-input').value,
                tagFilters: paramFilters,
                ...newProps
            });

            this.addDefaultBox();
        } else {
            this.setState({
                ...newProps
            });
        }
    },

    setState: function(newProps) {
        this.state = {
            ...this.state,
            ...newProps
        }

        if (Object.keys(newProps).includes('tagFilters') || Object.keys(newProps).includes('priceFilter') || Object.keys(newProps).includes('sortBy')) {
            this.createCSS();
        }

        this.render();
    },

    completeBox: async function(event) {
        const isFilled = Object.values(this.state.cardNotes)?.filter(item => typeof item === 'string')?.every(item => Boolean(item));
        if (!isFilled && !this.state.cardNotes.blank) {
            window.bundleApp.addClass(event, '.bundle-main', 'show-error-card');

            return;
        }

        const next = event.target.parentElement.querySelector('button[type="submit"]');

        const buttons = document.querySelectorAll('.bundle-builder--add-to-cart-form button');

        for (const button of buttons) {
            button.innerHTML = 'Processing...';
            button.style.opacity = .5;
            button.style.pointerEvents = 'none';
        }

        const quantity_forms = document.querySelectorAll('.bundle-builder--change-quantity-form');

        const variants = {};

        for (const quantity_form of quantity_forms) {
            const variant = quantity_form.querySelector('input[name="variant"]').value;
            const quantity = +quantity_form.querySelector('span').innerHTML;

            variants[variant] = {
                selected: quantity,
                in_stock: 0
            };
        }

        await $.get('https://unboxme.com/apps/bundles/api/v1/bundle?id=150180', function({products}, status){
            for (const variant_id of Object.keys(variants)) {
                const index = products.findIndex(({variants}) => variants.map(({id}) => id).includes(+variant_id));

                if (index !== -1) {
                    const {inventory_quantity} = products[index].variants.find(({id}) => id === +variant_id);

                    variants[variant_id].in_stock = inventory_quantity;
                }
            }
        });

        let validated = true;

        for (const variant in variants) {
            const message = document.querySelector(`.bundle-summary__products .bundle-summary__product[data-variant="${variant}"] > div:nth-child(2) .error-message`);

            const {selected, in_stock} = variants[variant];

            if (selected > in_stock) {
                validated = false;
                message.classList.remove('hidden');
            } else {
                message.classList.add('hidden');
            }
        }

        if (validated) {
           next.click();
        } else {
            for (const button of buttons) {
                button.innerHTML = 'Complete Box';
                button.style.opacity = 1;
                button.style.pointerEvents = 'auto';
            }

            if (window.innerWidth < 1000) {
                document.querySelector('.bundle-main').classList.add('out-of-stock-alert');

                if (document.body.classList.contains('bundle-summary-active')) {
                    const tags = document.querySelectorAll(`.bundle-summary__products .bundle-summary__product .error-message`);

                    const latest = Array.prototype.slice.call(tags).reverse().find(element => !element.classList.contains('hidden'));

                    const parent = latest.closest('.bundle-summary__product');

                    window.scrollTo({
                        top: (parent.getBoundingClientRect().top + window.scrollY) - 300,
                        behavior: 'smooth'
                    });
                }
            } else {
                const tags = document.querySelectorAll(`.bundle-summary__products .bundle-summary__product .error-message`);

                const latest = Array.prototype.slice.call(tags).reverse().find(element => !element.classList.contains('hidden'));

                const parent = latest.closest('.bundle-summary__product');

                window.scrollTo({top: 500, behavior: 'smooth'});

                document.querySelector('.bundle-summary').scrollTo({
                    top: latest.offsetTop - latest.offsetParent.offsetTop - 200,
                    behavior: 'smooth'
                });
            }
        }
    },

    expandBox: function(image) {
        if(!window.Fancybox || !image) {
          return;
        }

        window.Fancybox.show([
          {
            src: image,
            thumb: image,
          },
        ]);
    },

    addDefaultBox: function() {
        this.state.appRoot.querySelector('.bundle-builder--add-to-bundle-form .add-box').click();
    },

    addBox: function(event) {
        if (event.target.parentElement.querySelector('input').value !== this.state.boxIdToAdd) {
            this.state.appRoot.querySelector('#remove-selected-box').click();

            this.setState({
                boxIdToAdd: event.target.parentElement.querySelector('input').value
            });

            this.state.appRoot.querySelector('.add-box-input').value = event.target.parentElement.querySelector('input').value;
            this.state.appRoot.querySelector('.bundle-builder--add-to-bundle-form .add-box').click();
        }
    },

    modalOpenHandler: function(modalId) {
        /*
            Not in use
        */
        return

        this.setState({
            activeProductModal: modalId
        });
    },

    renderProductModal: function () {
        /*
            Not in use
        */
        return

        this.state.appRoot.querySelector('.product-modals-overlay').classList.remove('product-modals-overlay--active');

        this.state.appRoot.querySelectorAll('.product-modal').forEach(modal => {
            modal.classList.remove('product-modal--active');
            if (this.state.activeProductModal && this.state.activeProductModal === modal.id) {
                modal.classList.add('product-modal--active');
                this.state.appRoot.querySelector('.product-modals-overlay').classList.add('product-modals-overlay--active');

                this.initModalSliders();
            }
        });
    },

    initModalSliders: function() {
        const thumbSwiper = new window.Swiper('.product-modal--active .product-modal__thumbnails.swiper', {
            slidesPerView: 6,
            spaceBetween: 8
        });

        new window.Swiper('.product-modal--active .product-modal__images-main.swiper', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbSwiper,
            },
        });
    },

    initFilterSlider: function () {
        let filtersSwiper = null;
        const breakpoint = window.matchMedia('(max-width: 1000px)');
        breakpoint.addListener(checkBreakpoint)
        function checkBreakpoint() {
            if (breakpoint.matches && filtersSwiper == null) {
                handleSwiper(true)
            } else if (!breakpoint.matches && filtersSwiper !== null) {
                handleSwiper(false)
            }
        }

        function handleSwiper(enable) {
            if (enable) {
                filtersSwiper = new window.Swiper(".bundle-category-filters", {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                });
                return
            }

            filtersSwiper.destroy();
            filtersSwiper = null;
        }

        checkBreakpoint();
    },

    closeProductModal: function() {
        /*
            Not in use
        */
        return

        this.setState({
            activeProductModal: undefined
        });
    },

    toggleBundleSummary: function() {
        const isSummaryActive = document.querySelector('body').classList.contains('bundle-summary-active');

        if (this.state.currentSectionIndex === 0) {
            this.state.appRoot.querySelector('.bundle-content').parentElement.classList.toggle('hidden');
        }

        if (this.state.currentSectionIndex === 1) {
            if (isSummaryActive) {
                const scrollPosition = this.state.scrollPosition

                setTimeout(() => {
                    window.scrollTo({
                        top: scrollPosition,
                        // behavior: 'smooth'
                    })
                }, 400)

                this.setState({
                    scrollPosition: 0
                })
            } else {
                this.setState({
                    scrollPosition: window.scrollY || window.pageYOffset
                })

                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        // behavior: 'smooth'
                    })
                }, 400)
            }
        }

        const bundlePreview = document.querySelector('.btn-bundle-preview')
        if (bundlePreview) {
            if (isSummaryActive) {
                bundlePreview.textContent = bundlePreview.dataset.openText
            } else {
                bundlePreview.textContent = bundlePreview.dataset.closeText
            }
        }

        document.querySelector('body').classList.toggle('bundle-summary-active');
    },

    onNextStep: function () {
        document.querySelector('body').classList.remove('bundle-summary-active');

        const headerElm = document.querySelector('#header-root')
        const headerRect = headerElm.getBoundingClientRect()

        window.scrollTo({
            top: headerRect.height / 2
        })
    },

    toggleClass: function(event, element, className) {
        if (event) {
            event.target.closest(`${element}`).classList.toggle(`${className}`);
        } else {
            document.querySelector(`${element}`).classList.toggle(`${className}`);
        }
    },

    addClass: function(event, element, className) {
        if (event) {
            event.target.closest(`${element}`).classList.add(`${className}`);
        } else {
            document.querySelector(`${element}`).classList.add(`${className}`);
        }
    },

    removeClass: function(event, element, className) {
        if (event) {
            event.target.closest(`${element}`).classList.remove(`${className}`);
        } else {
            document.querySelector(`${element}`).classList.remove(`${className}`);
        }
    },

    accordionHandler: function(event) {
        this.state.appRoot.querySelectorAll('.product-filters__group').forEach(accordion => {
            if (event.target.closest('.product-filters__group') !== accordion) {
                accordion.classList.remove('product-filters__group--active');
            }
        });

        event.target.closest('.product-filters__group').classList.toggle('product-filters__group--active');
    },

    dropDownHandler: function(event) {
        if (event.target.localName === 'input') {
            this.state.appRoot.querySelector('.products-sorting__dropdown').value = event.target.value;
            this.removeClass(event, '.bundle-products-sorting', 'bundle-products-sorting--active');
            this.setState({
                sortBy: this.state.appRoot.querySelector('.products-sorting__dropdown').value
            });
        }
    },

    filterChangeHandler: function(event) {
        if (event.target.closest('.category-filter')) {
            if (event.target.checked) {
                const filters = [...this.state.tagFilters]
                filters.push(event.target.value);
                this.setState({
                    tagFilters: [...filters]
                });

                this.addClass(event, '.category-filter', 'category-filter--selected');
            } else {
                const filters = [...this.state.tagFilters]
                filters.splice(filters.indexOf(event.target.value), 1)
                this.setState({
                    tagFilters: [...filters]
                });

                this.removeClass(event, '.category-filter', 'category-filter--selected');
                this.state.appRoot.querySelector(`.selected-product-filter span[data-filter-item='${event.target.value}']`).parentElement.remove();
            }
        } else if (event.target.closest('.product-filters__group--price')) {
            if (event.target.id === 'min') {
                this.setState({
                    priceFilter: [+event.target.value, this.state.priceFilter[1]]
                });
            } else if (event.target.id === 'max') {
                if (event.target.value === '') {
                    this.setState({
                        priceFilter: [this.state.priceFilter[0], undefined]
                    });
                } else {
                    this.setState({
                        priceFilter: [this.state.priceFilter[0], +event.target.value]
                    });
                }
            }
        } else {
            if (event.target.checked) {
                const filters = [...this.state.tagFilters];
                filters.push(event.target.value);
                this.setState({
                    tagFilters: [...filters]
                });
            } else {
                const filters = [...this.state.tagFilters];
                filters.splice(filters.indexOf(event.target.value), 1);
                this.setState({
                    tagFilters: [...filters]
                });

                this.state.appRoot.querySelector(`.selected-product-filter span[data-filter-item='${event.target.value}']`).parentElement.remove();
            }
        }
    },

    removeFilter: function(event) {
        const filters = [...this.state.tagFilters];
        let selectedFilter = event.target.parentElement.querySelector('span').dataset.filterItem;
        filters.splice(filters.indexOf(selectedFilter), 1);
        this.setState({
            tagFilters: [...filters]
        });

        event.target.closest('.selected-product-filter').remove();
        this.state.appRoot.querySelector(`input[value='${selectedFilter}']`).checked = false;
        this.state.appRoot.querySelector(`.category-filter input[value='${selectedFilter}']`)?.parentElement.classList.remove('category-filter--selected');
    },

    resetFilters: function() {
        this.setState({
            tagFilters: []
        });

        this.state.appRoot.querySelectorAll('.category-filter').forEach(filter => {
            filter.classList.remove('category-filter--selected');
            filter.querySelector('input').checked = false;
        });

        this.state.appRoot.querySelectorAll('.bundle-product-filter input').forEach(input => {
            input.checked = false;
        });

        this.state.appRoot.querySelectorAll('.selected-product-filter').forEach(selectedFilter => {
            selectedFilter.remove();
        })
    },

    createCSS: function() {
        const allProducts = this.state.productsSection.filter((product) => {
            if (!product.soldOut) {
                let passed = true;
                let productPrice = product.price / 100;

                if (this.state.tagFilters.length > 0 && !this.state.tagFilters.every(tag => product.tags.includes(tag))) {
                    passed = false;
                }

                if (this.state.priceFilter.length > 0 && this.state.priceFilter[0] > productPrice || this.state.priceFilter[1] < productPrice) {
                    passed = false;
                }
                return passed;
            }
        }).sort((a, b) => {
            if (this.state.sortBy === 'Price: Low to high') {
                return a.price - b.price
            } else if (this.state.sortBy === 'Price: High to low') {
                return b.price - a.price;
            } else {
                return;
            }
        });

        const style = document.createElement('style');
        style.type = 'text/css';
        style.classList.add('app-style')
        let styleString = `.bundle-content--product .content-box {
            display: none;
        }`;

        allProducts.forEach(function(product, index) {
            styleString += `
            [data-product-id="${product.variantId}"] {
                display: grid !important;
                order: ${index};
            }
            `;
        });

        style.innerHTML = styleString;
        if (!document.querySelector('.app-style')) {
            document.querySelector('head').appendChild(style);
        } else {
            document.querySelector('.app-style').innerHTML = styleString;
        }
    },

    renderProduct: function() {
        this.state.tagFilters.forEach(filter => {
            if (!this.state.appRoot.querySelector(`.selected-product-filter span[data-filter-item='${filter}']`)) {
                let selectedFilterContainer = document.createElement('div');
                let selectedFilterText = document.createElement('span');
                let selectedFilterClose = document.createElement('span');

                selectedFilterContainer.classList.add('selected-product-filter');
                selectedFilterContainer.id = filter

                let filterName = filter.split('::');
                selectedFilterText.innerText = filterName[1];
                selectedFilterText.dataset.filterItem = `${filter}`;

                selectedFilterClose.innerText = '\u2715';
                selectedFilterClose.classList.add('remove-filter')
                selectedFilterClose.onclick = () => this.removeFilter(event);

                selectedFilterContainer.append(selectedFilterText, selectedFilterClose);
                this.state.appRoot.querySelector('.selected-product-filters').append(selectedFilterContainer);
            }
        });

        this.state.appRoot.querySelector('.products-sorting__dropdown').value = this.state.sortBy;
        this.state.appRoot.querySelector(`.products-sorting__dropdown__option input[value='${this.state.sortBy}']`).checked = true;

        if (this.state.tagFilters.length > 0) {
            this.state.tagFilters.forEach(filter => {
                this.state.appRoot.querySelector(`input[value='${filter}']`).checked = true;
                this.state.appRoot.querySelector(`input[value='${filter}']`).closest('.category-filter')?.classList.add('category-filter--selected');
            });
        }

        if (this.state.priceFilter.length > 0) {
            if (this.state.priceFilter[0]) {
                this.state.appRoot.querySelector('input#min').value = this.state.priceFilter[0];
            }

            if (this.state.priceFilter[1]) {
                this.state.appRoot.querySelector('input#max').value = this.state.priceFilter[1];
            }
        }
    },

    addCard: function(event) {
        const card = this.state.addedProducts.find((item) => item.index === 2);

        if (card) {
            this.state.appRoot.querySelector('#remove-selected-card').click();
        } else {
            this.setState({
                cardIdToAdd: event.target.parentElement.querySelector('input[name="variant"]').value
            });
        }

        event.target.parentElement.querySelector('button[type="submit"]').click();
        this.openCardModal();
    },

    fillCardNote: function() {
        const self = this;

        const toEl = this.state.appRoot.querySelector('#card-note-modal input[name="to"]')
        const fromEl = this.state.appRoot.querySelector('#card-note-modal input[name="from"]')
        const messageEl = this.state.appRoot.querySelector('#card-note-modal textarea[name="message"]')
        const checkboxEl = this.state.appRoot.querySelector('#card-note-modal #blank-card')

        const onToChange = (event) => {
            self.setState({
                cardNotes: {
                    ...self.state.cardNotes,
                    to: event.target.value
                }
            });
        }

        const onFromChange = (event) => {
            self.setState({
                cardNotes: {
                    ...self.state.cardNotes,
                    from: event.target.value
                }
            });
        }

        const onMessageChange = (event) => {
            self.setState({
                cardNotes: {
                    ...self.state.cardNotes,
                    message: event.target.value
                }
            });

            self.state.appRoot.querySelector('#card-note-modal #note-length').innerText = self.state.cardNotes.message.length;
        }

        const onMessageKeydown = (event) => {
            if (event.keyCode !== 8 && event.keyCode !== 46 && event.target.value.length >= 300) {
                event.preventDefault();
            }
        }

        const onCheckboxChange = (event) => {
            const isChecked = event.target.checked

            toEl.disabled = isChecked
            fromEl.disabled = isChecked
            messageEl.disabled = isChecked

            self.setState({
                cardNotes: {
                    ...self.state.cardNotes,
                    blank: isChecked
                }
            });
        }

        toEl.removeEventListener('change', onToChange)
        fromEl.removeEventListener('change', onFromChange)
        messageEl.removeEventListener('change', onMessageChange)
        messageEl.removeEventListener('keydown', onMessageKeydown)
        checkboxEl.removeEventListener('change', onCheckboxChange)

        toEl.addEventListener('change', onToChange);
        fromEl.addEventListener('change', onFromChange);
        messageEl.addEventListener('change', onMessageChange);
        messageEl.addEventListener('keydown', onMessageKeydown)
        checkboxEl.addEventListener('change', onCheckboxChange);
    },

    fillNote: function() {
        let card = this.state.addedProducts.find(function (item) {
            return item.index === 2;
        });
        let cardText;

        if (this.state.cardNotes.blank) {
            cardText = JSON.stringify({
                card: card === null || card === undefined ? undefined : card.name,
                skus: this.state.addedProducts.map(item => {
                    return {
                        quantity: item.quantity,
                        sku: item.sku
                    }
                })
            });
        } else {
            cardText = JSON.stringify({
                card: card === null || card === undefined ? undefined : card.name,
                to: this.state.cardNotes.to,
                from: this.state.cardNotes.from,
                message: this.state.cardNotes.message,
                skus: this.state.addedProducts.map(item => {
                    return {
                        quantity: item.quantity,
                        sku: item.sku
                    }
                })
            });
        }

        this.state.appRoot.querySelector('#bundle-builder-app--note-textarea').value = cardText;
        this.state.appRoot.querySelector('#bundle-builder-app--note-textarea').dispatchEvent(new Event('change'));
    },

    submitCardNote: function(event) {
        event.preventDefault();

        const onSetData = () => {
            this.closeCardModal();

            this.setState({
                cardModalSaved: true
            });

            this.fillNote();
        }

        const isChecked = this.state.cardNotes.blank || false

        if (!isChecked) {
            const formEl = this.state.appRoot.querySelector('#cart-form');
            if (!formEl) {
                return;
            }

            const toEl = formEl.querySelector('[name="to"]')
            const fromEl = formEl.querySelector('[name="from"]')
            const messageEl = formEl.querySelector('[name="message"]')

            if (toEl.value && fromEl.value && messageEl.value) {
                onSetData();
                return
            }

            window.Toastify('Please fill in all fields', 3000)
            return
        }

        onSetData();
    },

    hideSectionIndicators: function() {
        this.state.appRoot.querySelector('#bundle-step--3 .current-section-indicator-icon').style.display = 'none';
        this.state.appRoot.querySelector('#bundle-step--3 .section-title-sticker').style.display = 'none';
        this.state.appRoot.querySelector('#bundle-step--4 .current-section-indicator-icon').style.display = 'block';
    },

    openCardModal: function() {
        this.setState({
            cardModalOpen: true
        });

        // Block form inputs if checkbox is checked
        const isBlank = this.state.cardNotes.blank || false
        if (isBlank) {
            const formEl = this.state.appRoot.querySelector('#cart-form');
            if (!formEl) {
                return;
            }

            const toEl = formEl.querySelector('[name="to"]')
            const fromEl = formEl.querySelector('[name="from"]')
            const messageEl = formEl.querySelector('[name="message"]')

            toEl.disabled = true
            fromEl.disabled = true
            messageEl.disabled = true
        }

        this.state.appRoot.querySelector('.product-modal').classList.add('product-modal--active');
        this.state.appRoot.querySelector('.product-modals-overlay').classList.add('product-modals-overlay--active');
    },

    closeCardModal: function() {
        this.setState({
            cardModalOpen: false
        });
        this.state.appRoot.querySelector('.product-modal').classList.remove('product-modal--active');
        this.state.appRoot.querySelector('.product-modals-overlay').classList.remove('product-modals-overlay--active');
    },

    renderCardDetails: function() {
        if (this.state.cardModalOpen) {
            this.state.appRoot.querySelector('.product-modal').classList.add('product-modal--active');
            this.state.appRoot.querySelector('.product-modals-overlay').classList.add('product-modals-overlay--active');
            this.state.appRoot.querySelector('#blank-card').checked = this.state.cardNotes.blank;
        }

        if (this.state.cardNotes.to !== '' || this.state.cardNotes.from !== '' || this.state.cardNotes.message !== '') {
            this.state.appRoot.querySelector('#card-note-modal input[name="to"]').value = this.state.cardNotes.to;
            this.state.appRoot.querySelector('#card-note-modal input[name="from"]').value = this.state.cardNotes.from;
            this.state.appRoot.querySelector('#card-note-modal textarea#message').value = this.state.cardNotes.message;
            this.state.appRoot.querySelector('#card-note-modal #note-length').innerText = this.state.cardNotes.message.length;
        }
    },

    render: function() {
        if (document.querySelector('.bundler-loader')) {
            document.querySelector('.bundler-loader').classList.remove('bundler-loader')

           setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
           }, 400);
        }

        if (this.state.currentSectionIndex === 1) {
            this.initFilterSlider();
            // this.renderProductModal();
            this.renderProduct();
        }

        if (this.state.currentSectionIndex === 2) {
            this.renderCardDetails()
            this.fillCardNote();
            if (this.state.cardModalSaved) {
                this.hideSectionIndicators();
            }
        }

        if (window.bundler_shipping_bar_config && window.bundler_shipping_bar_config.price*1 > 0) {
            let price_block = document.querySelector('.bundle-summary__price');
            let shipping_block = document.querySelectorAll('.bundle-shipping-progress');
            if (shipping_block.length <= 0) {
                shipping_block = document.createElement('div');
                shipping_block.classList.add('bundle-shipping-progress');
                shipping_block.setAttribute('id','bundle-shipping-block');
                //shipping_block.style.display = "none";
                let phrase = document.createElement('div');
                phrase.classList.add('shipping-text');
                phrase.style.color = window.bundler_shipping_bar_config.text_color;
                phrase.innerHTML = window.bundler_shipping_bar_config.text;
                let progress_bar = document.createElement('div');
                progress_bar.classList.add('progress-bar');
                progress_bar.style.borderColor = window.bundler_shipping_bar_config.color;
                progress_bar.style.borderWidth = '1px';
                progress_bar.style.borderStyle = 'solid';
                let bar = document.createElement('div');
                bar.classList.add('bar');
                bar.style.height = '10px';
                bar.style.background = window.bundler_shipping_bar_config.color;
                bar.style.width = '0%';
                progress_bar.appendChild(bar);
                shipping_block.appendChild(phrase);
                shipping_block.appendChild(progress_bar);
                price_block.after(shipping_block);
                let clone = shipping_block.cloneNode(true);
                clone.classList.add('mobile-shipping-progress-bar');
                clone.setAttribute('id','bundle-shipping-block-mobile');
                //clone.style.display = "none";
                document.querySelector('.bundle-navigation--mobile').after(clone);
                shipping_block = document.querySelectorAll('.bundle-shipping-progress');
            }
            let price = price_block.querySelector('span');
            if (price) {
                price = (price.innerHTML.replace('$', '').replace('.', '') * 1);
                if (price && price > 0) {
                    let goal = window.bundler_shipping_bar_config.price * 100;
                    let width = (price / goal) * 100;
                    if (width > 100) width = 100;
                    shipping_block.forEach(function(item){
                        item.querySelector('.bar').style.width = width + '%';
                        let difference = (goal - price) / 100;
                        if (difference > 0) {
                            item.querySelector('.shipping-text').innerHTML = window.bundler_shipping_bar_config.text.replace('%d', difference.toString());
                        } else {
                            item.querySelector('.shipping-text').innerHTML = window.bundler_shipping_bar_config.text_finished;
                        }
                    });
                }
            }
        }
    }
}
